import $ from 'jquery';
import PubSub from 'PubSub';
import Offcanvas from 'components/offcanvas.js';
import "utils/logger";
import 'bootstrap';

export default function Service() {
  PubSub.subscribe('core.attach', $.proxy(this.attach, this));
  PubSub.subscribe('res', $.proxy(this.resxs, this));
  this.offcanvas = new Offcanvas('service-navi');
}

Service.prototype = {
  attach: function (msg, element) {

    $(document).trigger("ContentTreeLoaded");

    //Sidebar-Button open Toggle
    var toggleBtn = $('.service-list [data-toggle=offcanvas]');
    var _this = this;

    toggleBtn.off("click").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.offcanvas.toggle();
    });

    //Close
    $(".service-navi-controls .close-btn", element).off("click").on("click", function (e) {
      e.preventDefault();
      _this.offcanvas.hide();
    });

    $("ul.item-selling-points > li > span.truncatable-content").each(function () {
      var element = this;
      if (element.offsetHeight < element.scrollHeight ||
        element.offsetWidth < element.scrollWidth) {
        $(element).closest("li").addClass("truncated");
      }
    });

  },
  resxs: function (message, on_off) {
    if ((message === "res.xs" || message === "res.sm") && on_off) {
      this.isxs = on_off;
      this.offcanvas.switchIt(on_off);
    } else if ((message === "res.md" || message === "res.lg") && on_off) {
      this.isxs = false;
      this.offcanvas.switchIt(false);
    }

  }
};

$(".navi-button-a").on('click', function () {
  $(this).toggleClass("show-up");
});



